import { Expose, Type } from 'class-transformer';

import { SnModel } from '@lib/common/models';

import { OrganizationNotifyType } from './organization-notify-type';
import { UserNotifyType } from './user-notify';

export class FsNotifyChannel extends SnModel {
  @Expose() public id: string;
  @Expose() public name: string;
  @Expose() public description: string;
  @Expose() public phoneNumber: string;
  @Expose() public subscriberCount: number;
  @Expose() public messageCount: number;

  @Expose() @Type(() => Date) public createdTimestamp: Date;
  @Expose() @Type(() => Date) public updatedTimestamp: Date;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}

export class SnNotify extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public message: string;

  @Expose()
  @Type(() => FsNotifyChannel)
  public channel: FsNotifyChannel;

  @Expose()
  @Type(() => OrganizationNotifyType)
  public organization: OrganizationNotifyType;

  @Expose() @Type(() => Date) public createdTimestamp: Date;

  @Expose() @Type(() => Date) public updatedTimestamp: Date;

  @Expose()
  public status: string;

  @Expose()
  @Type(() => UserNotifyType)
  public user: UserNotifyType;

  @Expose()
  public zipCodes: [] = [];

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
